<template>
  <div></div>
</template>

<script>
  export default {
   data(){
     return {
     }
   },
   mounted () {},
   components:{},
   watch:{},
   computed:{},
   methods:{}
  }
</script>
<style scoped lang="scss">
</style>